<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card mb-2">
                        <div class="card-header">
                            <h3>Details View</h3>
                        </div>
                        <div class="card-body">
                            <template v-if="loading">
                                <loader></loader>
                            </template>
                            <template v-else>
                                <template  v-for="column in tableHead">
                                    <div class="row">
                                        <template v-for="item in column.items">                            
                                            <div :class="item.extremecustomOuterClass ? item.extremecustomOuterClass : 'col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12'">

                                                <table class="table m-0 detail-item-table">
                                                    <tr>
                                                        <td :class="item.extremecustomOuterClass ? 'label' : 'w-30 label'" :style="item.extremecustomOuterClass ? 'width: 100px;' : 'w-30 label'"> {{item.label}}</td>
                                                        <td>:</td>


                                                        <td class="w-70" v-if="item.radiotype==true">
                                                            <span v-if="product[item.name] == 1">Yes</span>
                                                            <span v-else-if="product[item.name] == 0">No</span>
                                                            <span v-else></span>
                                                        </td>
                                                        <td class="w-70" v-else-if="item.checkboxtype==true">
                                                            <span v-if="product[item.name] == 1">
                                                                <input type="checkbox" checked="true" disabled="disabled">
                                                            </span>
                                                            <span v-else-if="product[item.name] == 0">
                                                                <input type="checkbox" disabled="disabled">
                                                            </span>
                                                            <span v-else></span>
                                                        </td>

                                                        <td class="w-70" v-else-if="item.is_image==true">
                                                            <img :src="'/uploads/'+image_preview+'/'+product[item.name]"
                                                                alt="image Preview" class="avatar-img"
                                                                style="width: 60px;height: 60px;" />
                                                        </td>

                                                        <td class="w-70" v-else-if="item.link==true && !item.download == true">
                                                            <router-link
                                                                :to="'/modules/'+item.routePath+'/'+product[item.related_id]+'/detail'" style="word-break: break-all;">
                                                                {{product[item.name]}}
                                                            </router-link>
                                                        </td>
                                                        <td class="w-70" v-else-if="item.link==true && item.download == true && !Array.isArray(product[item.name])">
                                                        
                                                            <a href="javascript:void(0)"
                                                                @click="downloadPrivate(product.id, modules, product.doc_name)" style="word-break: break-all;">
                                                                {{product[item.name]}}
                                                            </a>
                                                        </td>
                                                        <td class="w-70 d-flex" v-else-if="item.link === true && item.download === true && Array.isArray(product[item.name])">
                                                        <template v-for="doc in product[item.name]">
                                                            <a href="javascript:void(0)"
                                                                @click="downloadPrivate(doc.doc_id, modules, doc.doc_name)" style="word-break: break-all;">
                                                                {{doc.doc_name}} &nbsp; | &nbsp;
                                                            </a>
                                                        </template>
                                                        </td>
                                                        <td  :class="item.extremecustomOuterClass ? '' : ''" v-else-if="item.name === 'description'"  style="word-break: break-all; width: 90%;"><textarea style="width: 100%; height: auto; padding: 10px;" disabled="true" rows="10">{{product[item.name]}}</textarea></td>
                                                        <td class="w-70" v-else>{{product[item.name]}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </template>

                        </div>
                    </div>
                </div>
            </div>
        </div>


    </main>
</template>

<script>
    import loader from "@/views/shared/loading/Loading.vue";
    export default {
        name: 'genericDetail',
        components: {
            loader
        },
        data() {
            return {
                loading: true,
                deleteProductModal: false,
                product: [],
                tableHead: [],
                record: null,
                modules: null,
                image_preview: null,
                loading: false,
            }
        },
        methods: {
            updateNotification() {
                const self = this;
                self.loading = true;
                let postData = {
                    parent_id: self.$route.params.id,
                    parent_type: 'TicketSystems',
                }
                axios.post('api/modules/notifications/read-notification', postData).then(function (response) {
                    self.loading = false;
                }).catch(function () {
                    self.loading = false;
                });
            },
            loadGenericView(metaList, routePath) {
                const self = this;
                self.loading = true;
                self.tableHead = metaList;
                self.record = self.$route.params.id;
                self.modules = routePath.path;
                axios.get(`api/modules/${self.modules}/${self.$route.params.id}`).then(function (response) {
                    self.product = response.data;
                    let created_date = (response.data.date_entered).split('-');
                    self.image_preview = `${created_date[0]}/${created_date[1]}`;

                    self.loading = false;
                    self.updateNotification();
                }).catch(function () {
                    self.loading = false;
                });
            },
            deleteProduct() {
                const self = this;
                axios.delete(`api/modules/${self.modules}/${self.$route.params.id}`).then(function () {
                    self.$notify({
                        title: self.$i18n.t('Success').toString(),
                        text: self.$i18n.t('Data deleted successfully').toString(),
                        type: 'success'
                    });
                    self.$router.push(`/modules/${self.modules}`);
                }).catch(function () {
                    self.loading = false;
                    self.deleteProductModal = false;
                });
            },
            downloadPrivate(doc_id, tbl,filename) {
            const self = this;
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Please login to download files');
                return;
            }
            
            axios.get(`api/modules/download/${doc_id}/${tbl}`, {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                params:{
                    filename:filename
                }
            }).then((response) => {
                //console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }).catch((error) => {
                console.error('Download failed:', error);
                self.$refs.notifyMsg.showAlert('Error', 'Download failed. File may not exist or access denied.');
            });
        }


        }
    }
</script>